/**
 * Mode-aware wrapper for students route.
 * Dispatches to in-person or remote page based on {@link useMode}.
 */

import { useMode } from '@/contexts/ModeContext';
import { StudentsManagementPage as StudentsInPersonManagementPage } from '@/components/pages/management-pages/inperson/StudentsManagementPage';
import { StudentsManagementPage as StudentsRemoteManagementPage } from '@/components/pages/management-pages/remote/StudentsManagementPage';

/** Mode-aware wrapper that mounts in-person or remote students. */
export function StudentsRouteDispatcher() {
  const { mode } = useMode();

  if (mode === 'remote') {
    return <StudentsRemoteManagementPage />;
  }

  return <StudentsInPersonManagementPage />;
}
